var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 257,
    viewBox: "0 0 665 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 256.5H0C24 254.5 34 231 36 219.5C36.5 216 34.8 202.8 36 176C37.2 149.2 61.5 140.833 73.5 140C124.333 140.5 231.2 141.2 252 140C272.8 138.8 284 115.833 287 104.5V77.5C289.8 46.3 314.5 38.1667 326.5 38H628C657.2 36 664.5 12.1667 664.5 0.5V91C657.3 62.6 635.167 57.1667 625 58H436C414.167 57.6667 363.8 57.2 337 58C310.2 58.8 300.5 82.3334 299 94V113.5C299.667 117.5 298.8 128.1 290 138.5C281.2 148.9 266.333 152.833 260 153.5C213.167 153.333 113.3 153.1 88.5 153.5C63.7 153.9 53.5 176.333 51.5 187.5C51 189.333 50.3 198.6 51.5 221C52.7 243.4 77 254 89 256.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSpace);
export default __webpack_public_path__ + "static/media/white_space.ce19a0a2ed2c69bc39494d7a5f007d7c.svg";
export { ForwardRef as ReactComponent };